import { type FunctionComponent } from "react";

import IconChinaFutureTech from "./china-future-tech-icon.svg";
import { PlusCftIndustryList } from "./industry-list";
import { BoldText, Container, DescriptionContainer, IconContainer } from "./styles";

type Props = {
  className?: string;
};

export const PlusCftHeader: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <IconContainer>
      <IconChinaFutureTech />
    </IconContainer>
    <DescriptionContainer>
      <BoldText>SCMP&apos;s China Future Tech</BoldText> is your go-to destination for the latest
      news, insights, and opinions on these select industries. Explore in-depth coverage of New
      Energy, AI, semiconductors, aerospace, robotics and biomedicine, sectors.
    </DescriptionContainer>
    <PlusCftIndustryList />
  </Container>
);

PlusCftHeader.displayName = "PlusCftHeader";
